var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23626 16L0 9.60618L2.84197 6.69241L6.23626 10.1828L16.158 0L19 2.91377L6.23626 16Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.71793cc03a38255b2e5d0962edbf6bb6.svg";
export { ForwardRef as ReactComponent };